/**
 * @Author: 黎丽
 * @Date: 2022/4/21 11:05
 * @LastEditTime: 2022/4/21 11:05
 * @LastEditors: 请填写最后一次编辑作者
 * @Description: 自定义Notification通知组件
 * @FilePath: BaseNotification.vue
 */
<template>
    <transition name="plus-icon" >
      <div class="socket" :class="{ 'content-shrink-right': isShrink }">
        <div class="message-wrao-allow" :class="{ 'is-shrink': isShrink }"  @click="isShrink = !isShrink">
          <i class="icon-allow el-icon-arrow-left"></i>
        </div>
          <ul class="message-wrap-ul strong">
            <template v-if="pendingCountData.length > 0">
              <i class="el-icon-close" style="margin-left:400px;position:relative;top:20px" @click="close()"></i>
              <li v-for="item in pendingCountData" :key="item.id">
                <p class="title">{{$lang(`${item.msgTitle}`)}}</p>
                <p class="message">{{$lang(`${item.msgContent}`)}}</p>
                <div class="btn-box">
                  <p>{{item.releaseDate}}</p>
                  <el-button type="primary" @click="closePrepayment(item.id)">{{$lang('知道了')}}</el-button>
                </div>
              </li>
            </template>
            <template v-else>
              <i class="el-icon-close" style="margin-left:400px;position:relative;top:20px" @click="close()"></i>
              <div class="empty">{{$lang('暂无数据')}}</div>
            </template>
          </ul>
      </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {},

  data() {
    return {
      // 收缩状态 false展开 true收缩
      isShrink: false,
      needDealtStatus: false
    }
  },
  computed: {
    ...mapGetters(['lang', 'token', 'menuList', 'permissWarperStatus'])
  },
  mounted() {

  },
  props: {
    isShowMsgContainerStatus: {
      type: Boolean,
      default: false
    },
    pendingCountData: {
      type: Array
    }
  },
  created() {},
  watch: {

  },

  methods: {
    close() {
      this.$store.commit('SET_STATUS', false)
    },
    async closePrepayment(id) {
      this.$emit('closePrepayment', id)
    }
  }
}
</script>

<style lang="scss" scoped>
.content-shrink-right{
  transform: translateX(420px);
  transition:all 500ms ease;
}
.socket {
  position: fixed;
  top: 74px;
  right: 0;
  width: 440px;
  min-height: 134px;
  z-index: 1020;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #dcdee1;
  transition:all 500ms ease;
  z-index: 9999;
  .message-wrao-allow {
    position: absolute;
    right: 100%;
    // right: 439px;
    // top: 120px;
    top: 33%;
    width: 15px;
    z-index: 1009;
    height: 50px;
    border:1px solid #dcdee1;
    border-radius: 10px 0 0 10px;
    border-right: none;
    transition: transform 500ms;
    background: #fff;
    .icon-allow {
      display: inline-block;
      position: relative;
      top: 13px;
      left: 2px;
      transform: rotate(180deg);
      color: #D4D6D9;
      cursor: pointer;
    }
    &.is-shrink {
      .icon-allow {
        transform: rotate(0deg);
      }
    }
  }
  .message-wrap-ul {
    width: 420px;
    list-style: none;
    li{
        margin-left: 24px;
        border-bottom: 1px solid #DCDEE1;
        margin-bottom: 20px;
        i{
          cursor: pointer;
        }
        .title {
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 400;
            color: #2b2d42;
            line-height: 20px;
        }
        .content{
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #61666d;
            line-height: 20px;
            margin-top: 10px;
        }
        .btn-box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 15px 0;
            p {
              color: #9499a3;
              line-height: 18px;
              font-size: 12px;
            }
        }
    }
    :last-child{
      border-bottom:none;
      // margin-top: 20px;
    }
  }
}
  .plus-icon-enter-active{
    transform: translateX(420px);
    transition: opacity .5s;
  }
  .plus-icon-enter{
     opacity: 0;
  }
  .plus-icon-leave-active{
    transform: translateX(420px);
    transition:all 500ms ease;
  }
  .plus-icon-leave-to{
    opacity: 0;
  }
  .el-icon-close{
    margin-left: 400px;
    position: relative;
    top: 30px;
    cursor: pointer;
  }
.message{
  width: 400px;
  color:#606266;
    font-size: 14px;
  padding-top: 10px;
  // overflow: hidden;/*超出部分隐藏*/
  white-space:normal;/*不换行*/
  // text-overflow:ellipsis;/*超出部分文字以...显示*/
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #9499A3;
  height: 110px;
}
</style>
